import { utcTime } from '../users/model';

export function expiresSoon(item: { is_active: boolean; expires_date: string | null }, now = Date.now()) {
  const expiry = item.expires_date ? utcTime(item.expires_date) : NaN;
  return item.is_active && expiry > now && expiry <= now + 7 * 86400000;
}
